import { Button, Grid2, Tooltip, Typography } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { WorkplaceBooking } from "../typings";

type Props = {
  booking: WorkplaceBooking[] | undefined;
  checkinAvailabilityColor: string;
  position: {
    center: { lat: number; lng: number };
    content: string;
    insideFence: boolean;
    fetchingDone: boolean;
    lastFetched: number;
  };
  handleGetGeoLocation: () => void;
};

export function CheckinHeader({
  booking,
  checkinAvailabilityColor,
  position,
  handleGetGeoLocation
}: Readonly<Props>) {
  const { t } = useTranslation();

  const requireBrowserGeolocSettingDesc = t("_geolocationbrowser");

  return (
    <div>
      {booking && (
        <Typography sx={{ ml: 2 }} variant={"h6"}>
          {t("Today's bookings")}
        </Typography>
      )}

      {!booking && (
        <Typography sx={{ ml: 2 }} variant={"h6"}>
          {t("There are no bookings for this workplace today")}
        </Typography>
      )}

      <Grid2 container justifyContent={"flex-start"} alignItems={"center"}>
        <Typography sx={{ marginLeft: "15px" }}>{t("Checkin availability")}</Typography>

        <FiberManualRecord sx={{ fill: checkinAvailabilityColor, margin: "0 5px" }} />

        {position.fetchingDone && !position.insideFence && position.content !== "Blocked" && (
          <Typography>{t("You have to be inside an 1km radius")}</Typography>
        )}
        {((position.fetchingDone && !position.insideFence && position.content === "Blocked") ||
          position.content === "Getting position...") && (
          <Tooltip
            title={<Typography>{requireBrowserGeolocSettingDesc}</Typography>}
            aria-label={requireBrowserGeolocSettingDesc}
          >
            <Button
              onClick={handleGetGeoLocation}
              color={"primary"}
              size={"small"}
              data-testid={"handleGetGeoLocation-btn"}
            >
              {t("Get geolocation")}
            </Button>
          </Tooltip>
        )}
      </Grid2>
    </div>
  );
}
